<adapt-dashboard-element *adaptLoadingUntilFirstEmit="let team of team$"
                         data-test="edit-team-locations"
                         name="Location"
                         [disableClick]="!canEditTeam"
                         (headerClicked)="editLocation(team)">
    <div adapt-dashboard-title-buttons>
        <button class="ms-auto"
                adaptButtonIcon="fal fa-sitemap"
                adaptTooltip="{{showMoreContext ? 'Hide' : 'Show'}} more context"
                [hideTooltipOnBlurred]="false"
                [(adaptButtonToggle)]="showMoreContext"></button>
        <button
                adaptButtonIcon="fal fa-users"
                adaptTooltip="{{showPeople ? 'Hide' : 'Show'}} team members"
                [hideTooltipOnBlurred]="false"
                [(adaptButtonToggle)]="showPeople"></button>
    </div>

    <div class="d-flex flex-column">
        <adapt-team-hierarchy-dashboard-element [team]="team"
                                                [showMoreContext]="showMoreContext"
                                                [showPeople]="showPeople"></adapt-team-hierarchy-dashboard-element>
    </div>
</adapt-dashboard-element>
